import { DropdownOptionType } from '../../../types/dropdown';

/* eslint-disable-next-line */
type DropdownProps = {
  defaultValue?: string;
  dropdownStyle?: string;
  options: DropdownOptionType[];
  onSelect: (brand: string) => void;
};

export function Dropdown(props: DropdownProps) {
  const {
    defaultValue,
    dropdownStyle = 'w-full md:w-1/4 h-10 bg-headerBackground p-2 text-caption md:text-subtitle uppercase font-MuseoSans100',
    options,
    onSelect
  } = props;

  const renderOptions = options.map((option) => {
    return (
      <option key={option?.id} value={option.optionValue}>
        {option.optionLabel}
      </option>
    );
  });

  return (
    <select
      className={`${dropdownStyle}`}
      value={defaultValue}
      onChange={(e) => onSelect(e.target.value)}
    >
      {renderOptions}
    </select>
  );
}

export default Dropdown;
